import Navbar from "@/components/Navbar";
import AdminChat from "@/components/AdminChat";
import { MessagesSquare } from "lucide-react";

export default function AdminChatPage() {
  return (
    <div className="App min-h-screen bg-slate-50">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <h1 className="font-heading text-2xl font-bold text-[#00133F] mb-4 flex items-center gap-2">
          <MessagesSquare className="w-6 h-6 text-[#F0005A]" /> Pusat Chat Konsumen
        </h1>
        <AdminChat heightClass="h-[calc(100vh-190px)]" />
      </div>
    </div>
  );
}
